import React from 'react';
export function Footer() {
  return <footer className="border-t border-brand-line bg-white px-4 py-8 text-center" data-id="element-116" data-mp="32wd2cf6gdjt0">
      <p className="text-sm text-brand-muted" data-id="element-117" data-mp="3gg11ma61ua0t">
        © 2026 Professeur de Danse Classique Pro — Tous droits réservés.
      </p>
    </footer>;
}